export default {
  async generateChartData(transactions, timePeriod, type, orderFee) {
    const MS_PER_HOUR = 3600 * 1000;
    const MS_PER_DAY = MS_PER_HOUR * 24;
    const MS_PER_WEEK = MS_PER_DAY * 7;
    const MS_PER_MONTH = MS_PER_DAY * 30;

    const filterTransactions = (transactions, timePeriod) => {
      let span = null

      switch (timePeriod) {
        case "day":
          span = MS_PER_DAY
          break;
        case "week":
          span = MS_PER_WEEK
          break;
        case "month":
          span = MS_PER_MONTH
          break;
        case "year":
          span = MS_PER_MONTH * 12
          break;
      }

      return transactions.filter(
        transaction => transaction.amount < 0 && transaction.created >= Date.now() - span
      );
    }

    const appendOrderValue = (transactions, orderFee) => {
      for (let i = 0; i < transactions.length; i++) {
        const transaction = transactions[i]
        if (!("orderValue" in transaction)) {
          const orderValue = (transaction.amount * -1 * 100) / (orderFee * 100)
          transactions[i].orderValue = Math.round(orderValue * 1e2) / 1e2
        }
      }

      return transactions
    }

    const groupByTimePeriod = (transactions, timePeriod) => {
      let groupedByTimePeriod = {};

      transactions.forEach(transaction => {
        let key = null
        let date = null

        switch (timePeriod) {
          case "day":
            key = new Date(transaction.created).setUTCMinutes(0, 0, 0)
            break;
          case "week":
            key = new Date(transaction.created).setUTCHours(0, 0, 0, 0)
            break;
          case "month":
            key = new Date(transaction.created).setUTCHours(0, 0, 0, 0)
            break;
          case "year":
            date = new Date(transaction.created)
            key = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1).getTime()
            break;
        }

        if (key in groupedByTimePeriod) groupedByTimePeriod[key].push(transaction)
        else groupedByTimePeriod[key] = [transaction]
      });

      return groupedByTimePeriod
    };

    const last12Months = () => {
      let dates = {}
      let d = new Date()
      let y = d.getUTCFullYear()
      let m = d.getUTCMonth()

      const padMonth = (month) => {
        if (month < 10) return '0' + month;
        return month;
      }

      if (m === 11) {
        for (let i = 1; i < 13; i++) {
          dates[new Date(y, padMonth(i - 1), 1).getTime()] = []
        }
      } else {
        for (let i = m + 1; i < m + 13; i++) {
          if ((i % 12) > m) dates[new Date(y - 1, padMonth(i), 1).getTime()] = []
          else dates[new Date(y, padMonth(i % 12), 1).getTime()] = []
        }
      }
      return dates;
    }

    const fillBlank = (groupedByTimePeriod, timePeriod) => {
      let maxKeys = null
      let span = null
      let lastKey = null

      switch (timePeriod) {
        case "day":
          maxKeys = 24
          span = MS_PER_HOUR
          lastKey = new Date().setUTCMinutes(0, 0, 0)
          break;
        case "week":
          maxKeys = 7
          span = MS_PER_DAY
          lastKey = new Date().setUTCHours(0, 0, 0, 0)
          break;
        case "month":
          maxKeys = 30
          span = MS_PER_DAY
          lastKey = new Date().setUTCHours(0, 0, 0, 0)
          break;
        case "year":
          maxKeys = 12
          break;
      }

      if (timePeriod !== "year") {
        let filledGroupedByTimePeriod = {}
        for (let i = 0; i < maxKeys; i++) {
          const key = Number(lastKey) - (i * span)
          if (key in groupedByTimePeriod) filledGroupedByTimePeriod[key] = groupedByTimePeriod[key]
          else filledGroupedByTimePeriod[key] = []
        }
        return filledGroupedByTimePeriod
      } else {
        let filledGroupedByTimePeriod = last12Months()
        const keys = Object.keys(filledGroupedByTimePeriod)

        keys.forEach(key => {
          if (key in groupedByTimePeriod) filledGroupedByTimePeriod[key] = groupedByTimePeriod[key]
        })
        return filledGroupedByTimePeriod
      }

    }

    const generateDataSeries = (filledGroupedByTimePeriod, type) => {
      let dataSeries = []

      switch (type) {
        case "orders":
          Object.keys(filledGroupedByTimePeriod).forEach(key => {
            dataSeries.push([Number(key), filledGroupedByTimePeriod[key].length])
          })
          break;
        case "ordersValue":
          Object.keys(filledGroupedByTimePeriod).forEach(key => {
            const transactions = filledGroupedByTimePeriod[key]
            if (transactions.length !== 0) {
              const total = transactions.reduce((sum, { orderValue }) => sum + orderValue, 0);
              const averageOrderValue = Math.round((total / transactions.length) * 1e2) / 1e2
              dataSeries.push([Number(key), averageOrderValue])
            } else dataSeries.push([Number(key), 0])
          })
          break;
        case "revenue":
          Object.keys(filledGroupedByTimePeriod).forEach(key => {
            const total = filledGroupedByTimePeriod[key].reduce((sum, { orderValue }) => sum + orderValue, 0);
            dataSeries.push([Number(key), Math.round(total * 1e2) / 1e2])
          })
          break;
        case "credits":
          Object.keys(filledGroupedByTimePeriod).forEach(key => {
            const total = filledGroupedByTimePeriod[key].reduce((sum, { amount }) => sum + (amount * -1), 0);
            dataSeries.push([Number(key), Math.round(total * 1e2) / 1e2])
          })
          break;
      }

      return dataSeries
    }

    const filteredTransactions = filterTransactions(transactions, timePeriod);
    const appendedOrderValue = appendOrderValue(filteredTransactions, orderFee)
    const groupedByTimePeriod = groupByTimePeriod(appendedOrderValue, timePeriod);
    const filledGroupedByTimePeriod = fillBlank(groupedByTimePeriod, timePeriod);
    const dataSeries = generateDataSeries(filledGroupedByTimePeriod, type)
    return dataSeries
  }
};
